import React, { useState } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Esto funciona si ya tengo muchos olvidos?',
  a: 'Sí, el método está diseñado para reactivar conexiones que han estado inactivas, sin importar el punto de partida.'
}, {
  q: '¿Necesito saber mucho de tecnología?',
  a: 'Para nada. Es un archivo PDF fácil de abrir en cualquier teléfono, tableta o computadora, e ideal para imprimir.'
}, {
  q: '¿Cuánto tiempo toma ver resultados?',
  a: 'La agilidad mental se siente desde la primera sesión de ejercicios, pero los cambios permanentes se consolidan a los 21 días.'
}, {
  q: '¿Es un pago único?',
  a: 'Sí, usted paga una sola vez y el material es suyo de por vida.'
}, {
  q: '¿Puedo compartirlo con mi esposo?',
  a: 'Claro, el entrenamiento es beneficioso para cualquier persona que quiera proteger su mente.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream-50 py-24 md:py-32 px-6" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <FadeIn data-id="element-3">
          <div className="text-center mb-16" data-id="element-4">
            <h2 className="font-serif text-3xl md:text-4xl text-navy-900 font-bold mb-4" data-id="element-5">
              Preguntas Frecuentes
            </h2>
            <div className="w-16 h-1 bg-gold-400 mx-auto rounded-full" data-id="element-6"></div>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-7">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <FadeIn key={index} delay={index * 0.1} data-id="element-8">
                <div className="bg-white rounded-2xl border border-cream-200 overflow-hidden" data-id="element-9">
                  <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full text-left px-6 py-6 flex items-center justify-between focus:outline-none" aria-expanded={isOpen} data-id="element-10">
                    <span className="text-lg md:text-xl font-bold text-navy-900 pr-8" data-id="element-11">
                      {faq.q}
                    </span>
                    <ChevronDown className={`w-6 h-6 text-gold-500 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-12" />
                  </button>

                  <AnimatePresence data-id="element-13">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-14">
                        <div className="px-6 pb-6 text-lg text-charcoal-700 leading-relaxed" data-id="element-15">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}